import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a2b19d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simulator-contents" }
const _hoisted_2 = { class: "uk-margin" }
const _hoisted_3 = {
  class: "simulator-contents__grid uk-flex-center uk-grid-collapse",
  "uk-grid": ""
}
const _hoisted_4 = { class: "simulator-contents__block uk-text-center uk-width-1-1 uk-width-1-3@s uk-width-1-4@l" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "storage/lp/initial.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "title uk-text-large uk-text-bold" }, [
    /*#__PURE__*/_createTextVNode("初期費用"),
    /*#__PURE__*/_createElementVNode("span", { class: "uk-margin-small-left uk-text-small uk-text-normal" }, "※1")
  ])
], -1 /* HOISTED */))
const _hoisted_6 = { class: "price uk-margin-small uk-text-bold" }
const _hoisted_7 = { class: "simulator-contents__block uk-text-center uk-width-1-1 uk-width-1-3@s uk-width-1-4@l" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "storage/lp/population.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "title uk-text-large uk-text-bold" }, [
    /*#__PURE__*/_createTextVNode("サーバー利用料"),
    /*#__PURE__*/_createElementVNode("span", { class: "uk-margin-small-left uk-text-small uk-text-normal" }, "※2")
  ])
], -1 /* HOISTED */))
const _hoisted_9 = { class: "simulator-body uk-flex uk-flex-middle uk-flex-center uk-margin-small" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "uk-text-bold uk-inline-block" }, [
    /*#__PURE__*/_createTextVNode("都市"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("人口")
  ])
], -1 /* HOISTED */))
const _hoisted_11 = { class: "uk-width-2-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "uk-text-bold uk-text-large uk-inline-block" }, "万人")
], -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uk-text-small" }, "万人は整数、1万人単位となります。")
], -1 /* HOISTED */))
const _hoisted_14 = { class: "simulator-contents__block uk-text-center uk-width-1-1 uk-width-1-3@s uk-width-1-4@l" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "storage/lp/kanri.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "title uk-text-large uk-text-bold" }, [
    /*#__PURE__*/_createTextVNode("保守管理費用"),
    /*#__PURE__*/_createElementVNode("span", { class: "uk-margin-small-left uk-text-small uk-text-normal" }, "※3")
  ])
], -1 /* HOISTED */))
const _hoisted_16 = { class: "price uk-margin-small uk-text-bold" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-margin-small-left uk-text-bold uk-text-large" }, "/ 年", -1 /* HOISTED */))
const _hoisted_18 = { class: "result uk-margin-medium" }
const _hoisted_19 = { class: "uk-text-center uk-text-bold uk-margin-medium" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("シミュレーション結果")
const _hoisted_21 = {
  key: 0,
  class: "uk-text-small uk-display-block"
}
const _hoisted_22 = {
  key: 0,
  class: "result-body uk-card uk-card-default uk-card-body"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "head uk-text-bold" }, "災害リスク・防災情報の見える化システム導入時のご利用料金", -1 /* HOISTED */))
const _hoisted_24 = { class: "result-block uk-flex-center uk-flex uk-flex-middle" }
const _hoisted_25 = {
  class: "uk-flex uk-grid-small uk-flex-middle uk-flex-center uk-flex-top@s",
  "uk-grid": ""
}
const _hoisted_26 = { class: "uk-flex uk-flex-column uk-flex-middle" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("初期費用")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("[ ")
const _hoisted_29 = { class: "uk-text-bold is-larger" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" ]")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-visible@s" }, " ", -1 /* HOISTED */))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-flex uk-flex-column uk-flex-middle" }, [
  /*#__PURE__*/_createTextVNode("年間サーバー利用料"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("[ "),
    /*#__PURE__*/_createElementVNode("span", { class: "uk-text-bold is-larger" }, "応相談"),
    /*#__PURE__*/_createTextVNode(" ]")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "uk-visible@s" }, " ")
], -1 /* HOISTED */))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_35 = { class: "uk-flex uk-flex-column uk-flex-middle" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("年間保守管理費用")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("[ ")
const _hoisted_38 = { class: "uk-text-bold is-larger" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" ]")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(月額30,000円)", -1 /* HOISTED */))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "uk-margin" }, null, -1 /* HOISTED */))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uk-text-center result-foot" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "uk-text-bold",
    href: "#inquiry",
    "uk-scroll": ""
  }, "お問い合わせ")
], -1 /* HOISTED */))
const _hoisted_43 = {
  key: 1,
  class: "result-body uk-card uk-card-default uk-card-body"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "head uk-text-bold" }, "災害リスク・防災情報の見える化システム導入時のご利用料金", -1 /* HOISTED */))
const _hoisted_45 = { class: "result-block uk-flex-between uk-flex uk-flex-middle" }
const _hoisted_46 = {
  class: "uk-flex uk-grid-small uk-flex-middle uk-flex-top@s",
  "uk-grid": ""
}
const _hoisted_47 = { class: "uk-flex uk-flex-column uk-flex-middle" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("初期費用")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("[ ")
const _hoisted_50 = { class: "uk-text-bold is-larger" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" ]")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-visible@s" }, " ", -1 /* HOISTED */))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_54 = { class: "uk-flex uk-flex-column uk-flex-middle" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("年間サーバー利用料")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("[ ")
const _hoisted_57 = {
  key: 0,
  class: "uk-text-bold is-larger"
}
const _hoisted_58 = {
  key: 1,
  class: "uk-text-bold is-larger"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" ]")
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_61 = { class: "uk-flex uk-flex-column uk-flex-middle" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("年間保守管理費用")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("[ ")
const _hoisted_64 = { class: "uk-text-bold is-larger" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" ]")
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(月額30,000円)", -1 /* HOISTED */))
const _hoisted_67 = {
  key: 0,
  class: "uk-text-bold uk-text-large"
}
const _hoisted_68 = /*#__PURE__*/_createTextVNode("初年度 合計 ")
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "uk-hidden@m" }, null, -1 /* HOISTED */))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "uk-margin" }, null, -1 /* HOISTED */))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uk-text-center result-foot" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "uk-text-bold",
    href: "./#inquiry"
  }, "お問い合わせ")
], -1 /* HOISTED */))
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"caution uk-margin-large\" data-v-2a2b19d2><ul class=\"uk-list\" data-v-2a2b19d2><li class=\"uk-text-small\" data-v-2a2b19d2>初期費用は災害リスク・防災情報の見える化システム導入時のみ発生し、次年度からは不要です。</li><li class=\"uk-text-small\" data-v-2a2b19d2>月々のサーバー利用料は月額基本利用料50,000円＋都市人口に応じた金額となります。人口40万人を超える場合は別途ご相談ください。<br data-v-2a2b19d2>広域災害発生時など、想定利用者数を超えた分のサーバー利用料は別途お見積りとなる場合がございます。</li><li class=\"uk-text-small\" data-v-2a2b19d2>保守管理費用は月々30,000円となります。<br data-v-2a2b19d2>表示価格はすべて税抜です。</li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.initialCost.toLocaleString()) + "円", 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                class: "input-population uk-input uk-form-large",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.postPopulace) = $event)),
                min: "2"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  $setup.postPopulace,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _hoisted_12
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", _hoisted_16, [
            _createTextVNode(_toDisplayString($setup.maintenanceCost.toLocaleString()) + "円", 1 /* TEXT */),
            _hoisted_17
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h3", _hoisted_19, [
          _hoisted_20,
          (!$setup.postPopulace)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "都市人口を入力してください"))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            ($setup.postPopulace >= 41)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("span", null, [
                          _hoisted_28,
                          _createElementVNode("span", _hoisted_29, _toDisplayString($setup.initialCost.toLocaleString()) + "円", 1 /* TEXT */),
                          _hoisted_30
                        ]),
                        _hoisted_31
                      ]),
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("span", null, [
                          _hoisted_37,
                          _createElementVNode("span", _hoisted_38, _toDisplayString($setup.maintenanceCost.toLocaleString()) + "円", 1 /* TEXT */),
                          _hoisted_39
                        ]),
                        _hoisted_40
                      ])
                    ])
                  ]),
                  _hoisted_41,
                  _hoisted_42
                ]))
              : ($setup.postPopulace && $setup.serverPrice !== false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("span", null, [
                            _hoisted_49,
                            _createElementVNode("span", _hoisted_50, _toDisplayString($setup.initialCost.toLocaleString()) + "円", 1 /* TEXT */),
                            _hoisted_51
                          ]),
                          _hoisted_52
                        ]),
                        _hoisted_53,
                        _createElementVNode("span", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("span", null, [
                            _hoisted_56,
                            ($setup.postPopulace)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString($setup.serverPrice.toLocaleString()) + "円", 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("span", _hoisted_58, "50,000円")),
                            _hoisted_59
                          ]),
                          _createElementVNode("span", null, "(月額" + _toDisplayString(Math.ceil($setup.serverPrice / 12).toLocaleString()) + "円)", 1 /* TEXT */)
                        ]),
                        _hoisted_60,
                        _createElementVNode("span", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("span", null, [
                            _hoisted_63,
                            _createElementVNode("span", _hoisted_64, _toDisplayString($setup.maintenanceCost.toLocaleString()) + "円", 1 /* TEXT */),
                            _hoisted_65
                          ]),
                          _hoisted_66
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        ($setup.postPopulace)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                              _hoisted_68,
                              _hoisted_69,
                              _createTextVNode(_toDisplayString($setup.result.toLocaleString()) + "円", 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _hoisted_70,
                    _hoisted_71
                  ]))
                : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _hoisted_72
      ])
    ])
  ]))
}